/*
		Tween,

			a 'tween'ing library.
			This module has a timer which it uses to tween a value between two 'start' and 'end' values over 'period' milliseconds.
			A number of different algorithms are supported.
 */

var Class = require('./class.js');

/*
		Tween,
			a controller that changes something using 'tween' frames.
			target - the object to update
			prop - the property on that object to update
			suffix - a string to append to the property value (can be null/undefined)
			algo - the algorithm to tween with
			start - the starting value (this is set on the object when start() is called)
			end - the ending value (this is set on the object when stop() is called, and when it comes to it's own end)
			period - how long to take to tween from start - end
			obj - a context for callbacks
			onChange - a callback called whenever we change target[prop]
			onStop - a callback called when the tween stops (either manual or automatic)
 */

module.exports.Tween = Class(null, {
	__init__: function(target, prop, suffix, algo, begin, end, period, obj, onChange, onStop) {
		this.target = target;
		this.prop = prop;
		this.suffix = suffix || '';
		this.algo = algo;
		this.begin = begin;
		this.end = end;
		this.period = period;
		this.obj = obj;
		this.onChange = onChange;
		this.onStop = onStop;
		this.value = begin;
		this.running = false;
	},

	setValue: function(val) {
		if(this.target)
			this.target[this.prop] = val + this.suffix;
		this.value = val;
		if(this.onChange)
			this.onChange.call(this.obj, val);
	},

	start: function() {
		this._starttime = new Date().getTime();
		this.setValue(this.begin);
		this.running = true;
	},

	step: function() {
		var t = new Date().getTime() - this._starttime;
		if(t >= this.period)
			this.stop();
		else {
			var val = this.algo(t, this.begin, this.end - this.begin, this.period);
			this.setValue(val);
		}
	},

	stop: function() {
		this.setValue(this.end);
		if(this.onStop)
			this.onStop.call(this.obj);
		this.running = false;
	}
});


module.exports.Tweener = Class(null, {
	__init__: function(interval) {
		this.interval = interval;
		this.active = false;
		this.tweens = [];
	},

	run: function(tween) {
		this.tweens.push(tween);
		tween.start();
		if(! this.active) {
			this.active = true;
			this.tick();
		}
	},

	tick: function() {
		for(var i = 0; i < this.tweens.length; i++)
			this.tweens[i].step();
		var running = [];
		for(var i = 0; i < this.tweens.length; i++)
			if(this.tweens[i].running)
				running.push(this.tweens[i]);
		this.tweens = running;
		if(running.length > 0)
			window.setTimeout(this.tick.bind(this), this.interval);
		else
			this.active = false;
	}
});


/*
	Tween algorithms:

		credit to jstween - http://jstween.blogspot.com/

		each algorithm is written as a function with the follow parameters:
			t - the current time value
			b - the beginning position
			c - the delta (end - beginning) of the whole tween
			d - tween period (time where the tween should end)
 */

module.exports.TweenAlgorithm = {
	backEaseIn: function(t,b,c,d,a,p) {
		var s = 1.70158;
		return c*(t/=d)*t*((s+1)*t - s) + b;
	},

	backEaseOut: function(t,b,c,d,a,p) {
		var s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	},

	backEaseInOut: function(t,b,c,d,a,p) {
		var s = 1.70158; 
		if((t/=d/2) < 1)
			return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
		return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
	},

	elasticEaseIn: function(t,b,c,d,a,p) {
		if(t == 0)
			return b; 
		if((t/=d)==1)
			return b+c;  
		if(!p) p=d*.3;
		if(!a || a < Math.abs(c)) {
			a=c;
			var s = p / 4;
		}
		else
			var s = p / (2 * Math.PI) * Math.asin(c / a);
		return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
	},

	elasticEaseOut: function(t,b,c,d,a,p) {
		if(t == 0)
			return b;
		if((t/=d)==1)
			return b+c;
		if(!p)
			p=d*.3;
		if(!a || a < Math.abs(c)) {
			a=c;
			var s=p/4;
		}
		else
			var s = p/(2*Math.PI) * Math.asin (c/a);
		return(a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b);
	},

	elasticEaseInOut: function(t,b,c,d,a,p) {
		if(t == 0)
			return b;
		if((t/=d/2)==2)
			return b+c;
		if(!p)
			var p=d*(.3*1.5);
		if(!a || a < Math.abs(c)) {
			var a=c;
			var s=p/4;
		}
		else
			var s = p/(2*Math.PI) * Math.asin (c/a);
		if(t < 1)
			return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
	},

	bounceEaseOut: function(t,b,c,d) {
		if ((t/=d) < (1/2.75)) {
			return c*(7.5625*t*t) + b;
		}
		else if (t < (2/2.75)) {
			return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
		}
		else if (t < (2.5/2.75)) {
			return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
		}
		else {
			return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
		}
	},

	bounceEaseIn: function(t,b,c,d) {
		return c - TweenAlgorithm.bounceEaseOut(d-t, 0, c, d) + b;
	},

	bounceEaseInOut: function(t,b,c,d) {
		if (t < d/2)
			return TweenAlgorithm.bounceEaseIn(t*2, 0, c, d) * .5 + b;
		else
			return TweenAlgorithm.bounceEaseOut(t*2-d, 0, c, d) * .5 + c*.5 + b;
	},

	strongEaseInOut: function(t,b,c,d) {
		return c*(t/=d)*t*t*t*t + b;
	},

	regularEaseIn: function(t,b,c,d) {
		return c*(t/=d)*t + b;
	},

	regularEaseOut: function(t,b,c,d) {
		return -c *(t/=d)*(t-2) + b;
	},

	regularEaseInOut: function(t,b,c,d) {
		if ((t/=d/2) < 1)
			return c/2*t*t + b;
		return -c/2 * ((--t)*(t-2) - 1) + b;
	},

	strongEaseIn: function(t,b,c,d) {
		return c*(t/=d)*t*t*t*t + b;
	},

	strongEaseOut: function(t,b,c,d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	},

	strongEaseInOut: function(t,b,c,d) {
		if ((t/=d/2) < 1)
			return c/2*t*t*t*t*t + b;
		return
			c/2*((t-=2)*t*t*t*t + 2) + b;
	}
};

